import request from '@/utils/request';

/**
 * 归属小程序
 */
export function companyappApi(params) {
  return request({
    url: '/admin/companyapp/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 分页列表
 */
export function companyDesignListApi(params) {
  return request({
    url: '/admin/company-design/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增
 */
export function saveApi(data) {
  return request({
    url: '/admin/company-design/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 */
export function deleteApi(params) {
  return request({
    url: '/admin/company-design/delete',
    method: 'GET',
    params: params
  });
}

/**
 * 修改
 */
export function updateApi(data) {
  return request({
    url: '/admin/company-design/update',
    method: 'POST',
    data: data
  });
}

/**
 * 禁用
 */
export function disableState(params) {
  return request({
    url: '/admin/company-design/disable',
    method: 'get',
    params: params
  });
}

/**
 * 启用
 */
export function enableState(params) {
  return request({
    url: '/admin/company-design/enable',
    method: 'get',
    params: params
  });
}